import { AccessType, ElevatorType } from "src/app/job/job-overview/overview-locations/overview-locations.state";

export const buildingTypes = [
  'Apartment/Condo',
  'House',
  'Townhouse',
  'Duplex',
  'Commercial',
  'Storage Unit',
  'Office',
  'Other',
] as const;

export type BuildingType = typeof buildingTypes[number];

export const storageSizes = [
  '5x5',
  '5x10',
  '10x10',
  '10x15',
  '10x20',
  '10x30',
] as const;

export type StorageSize = typeof storageSizes[number];

export const officeSizes = [
  'home_office',
  'small_office',
  'medium_office',
  'large_commercial',
] as const;

export type OfficeSize = typeof officeSizes[number];

export const otherSizes = [
  'small_load',
  'medium_load',
  'large_load',
  'xl_load',
] as const;

export type OtherSize = typeof otherSizes[number];

export const sizes = [
  'studio',
  '1bed',
  '2bed',
  '3bed',
  '4bed',
  ...storageSizes,
  ...officeSizes,
  ...otherSizes,
] as const;

export type BuildingSize = typeof sizes[number];

export type LocationDetailsWizardOptionValue = BuildingType | BuildingSize | AccessType | ElevatorType | number;

export type LocationDetailsWizardStep = 'buildingType' | 'size' | 'access' | 'elevatorType' | 'floor';

export type LocationDetailsWizardAnswers = {
  [K in LocationDetailsWizardStep]:
    K extends 'buildingType'
      ? BuildingType
      : K extends 'size'
        ? BuildingSize
        : K extends 'access'
          ? AccessType
          : K extends 'elevatorType'
            ? ElevatorType
            : K extends 'floor'
              ? number
              : never;
};

export type LocationDetailsWizardTrigger = 'autocomplete' | 'button';

export const locationDetailsWizardInitialState = {
  locationType: undefined as 'start' | 'end' | undefined,
  trigger: undefined as LocationDetailsWizardTrigger | undefined,
  step: 'buildingType' as LocationDetailsWizardStep | undefined,
  answers: {} as Partial<LocationDetailsWizardAnswers>,
};

export type LocationDetailsWizardState = typeof locationDetailsWizardInitialState;

export const buildingTypesWithAccess: BuildingType[] = [
  'Apartment/Condo',
  'Storage Unit',
  'Other',
];
